import useInternalLink from '~/composables/useInternalLinkGraphQL';
var isMenuOpen = ref(false);
export default function () {
  function toggleMenu() {
    isMenuOpen.value = !isMenuOpen.value;
  }
  function openMenu() {
    isMenuOpen.value = true;
  }
  function closeMenu() {
    isMenuOpen.value = false;
  }
  function isLinkWithInternalLink(item) {
    return 'internalLink' in item && !!item.internalLink;
  }
  function isLinkWithUrl(item) {
    return 'url' in item;
  }
  function isLinkWithExternalUrl(item) {
    return 'externalLinkUrl' in item;
  }

  /**
   * Gets the item link.
   *
   * @param      {Object}  item    The item
   * @return     {String}  The item link.
   */
  function getMenuItemLink(item) {
    if (isLinkWithInternalLink(item)) {
      var _useInternalLink = useInternalLink(item.internalLink),
        internalLink = _useInternalLink.internalLink;
      return internalLink.value;
    }
    if (isLinkWithUrl(item)) {
      return item.url;
    }
    if (isLinkWithExternalUrl(item)) {
      return item.externalLinkUrl;
    }
    return null;
  }
  return {
    isMenuOpen: isMenuOpen,
    toggleMenu: toggleMenu,
    openMenu: openMenu,
    closeMenu: closeMenu,
    getMenuItemLink: getMenuItemLink
  };
}